import React, { memo } from 'react';

// styles
import './style.scss';
import CustomIcons from 'components/CustomIcons';
import { useHistory } from 'react-router-dom';

function AbsenceInfo({ user }) {
  const history = useHistory();

  return (
    <div className="absence-info">
      <div className="absence-info--card card--unprocessed">
        <div className="absence-info--card__info">
          <div className="absence-info--card__info-icon">
            <CustomIcons type="absence" />
          </div>

          <div className="absence-info--card__info-text">
            <span className="absence-info--card__info-text-number">
              {user?.amountAbsences || 0}
            </span>
            <p className="absence-info--card__info-text-description">
              Absence(s) à traiter
            </p>
          </div>
        </div>
        <CustomIcons
          className="absence-info--card__arrow-btn"
          type="arrow-right"
          onClick={() => {
            history.push({
              pathname: `/absences`,
            });
          }}
        />
      </div>
      <div className="absence-info--card card--teachers">
        <div className="absence-info--card__info">
          <div className="absence-info--card__info-icon">
            <CustomIcons type="person" />
          </div>
          <div className="absence-info--card__info-text">
            <span className="absence-info--card__info-text-number">
              {user?.amountAbsences || 0}
            </span>
            <p className="absence-info--card__info-text-description">
              Enseignant(s) absent(s)
            </p>
          </div>
        </div>
        <CustomIcons
          className="absence-info--card__arrow-btn"
          type="arrow-right"
          onClick={() => {
            history.push({
              pathname: `/absences`,
            });
          }}
        />
      </div>
    </div>
  );
}

AbsenceInfo.defaultProps = {};
AbsenceInfo.propTypes = {};

export default memo(AbsenceInfo);
